<template>
  <div>
    <b-card>
      <b-row class="px-1 align-items-center justify-content-between">
        <h5> طلبات المنحة المالية </h5>
        <div v-can="{ slug: $route.meta.instructionsSlug, action: 'C' }">
          <!-- <b-button
            variant="success d-flex align-items-center"
            @click="financialGrantModal = true "
          >
            <feather-icon size="18" icon="PlusIcon" />
            <span class="mx-25"> إضافة </span>
          </b-button> -->
        </div>
      </b-row>
      <hr />
      
    <data-table
      ep="v2/financial-grants"
      id="projects"
      :fields="fields"
      striped
      ref="financialGrantTable"
    >

      <template #cell(_)="row">
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="flat-info"
            @click="row.toggleDetails"
            title="عرض المزيد من المعلومات"
            size="sm"
            class="btn-icon rounded-circle"
            v-b-tooltip.hover.v-info.top
          >
            <feather-icon icon="InfoIcon" size="1.8x" color="#82868b" />
          </b-button>
         
        </div>
      </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col md="12" class="mb-1 d-flex">
              <strong>أوجه الإنفاق المُراد توظيف الإعانة فيها :</strong>
              <div class="text-info mx-1" v-html="row.item.expenditures"></div>
            </b-col>
          </b-row>

          <b-button
            size="sm"
            variant="outline-secondary"
            @click="row.toggleDetails"
          >
            عرض اقل
          </b-button>
        </b-card>
      </template>
    </data-table>
    <financial-grant-modal
      :loading="loading"
      mainTitle="بيانات معاملة طلب منحة مالية"
      @confirm="onConfirmAddRequest"
      v-model="financialGrantModal"
      :intializeForm="form"
      ref="financialGrantModal"
    />

    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormFile, BButton , BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";
import FinancialGrantModal from "@/modules/ngo/transactions/components/Add/FinancialGrantModal.vue";
import DataTable from "@/components/data-table";
import FormModal from "@/components/FormModal.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import FormFileInput from "@/components/FormFileInput.vue";
import { mapGetters, mapActions } from "vuex";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    DataTable,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BButton,
    FormModal,
    FormCleave,
    FormCurrency,
    FormFileInput,
    BDropdown, BDropdownItem, VBTooltip , FinancialGrantModal
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      isFormShown: false,
      financialGrantModal : false ,
      isEdit: false,
      form :{} ,
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        // {
        //   key: "ngo.name_ar",
        //   label: "اسم المنظمة",
        // },
        {
          key: "ngoBankAccount.account_no",
          label: "الحساب المصرفي",
        },
        "_",
      ],
    };
  },
  computed: {
    ...mapGetters("Financial", ["working"]),
    ...mapGetters("Financial/Transactions/Transactions", ["loading"]),
  },
  methods: {
    ...mapActions("Financial", [
      "editFinancialData",
      "addFinancialData",
      "deleteFinancialGrant",
    ]),
    ...mapActions("Financial/Transactions/Transactions", [
      "createTransactions",
    ]),
    getYears() {
      var x = [];
      for (let index = 1950; index < this.$moment().year(); index++) {
        x.push(`${index}`);
      }
      return x.reverse();
    },
    onDeleteClicked(item) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستند ؟", {
          title: "تأكيد حذف المستند",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteFinancialGrant(item.id).then(() => {
              this.$refs.financialGrantTable.refreshTable();
            });
          }
        });
    },
    onEditClicked(form) {
      this.$refs.financialDataForm.init({
        id: form.id,
        year: form.year,
        final_budget: form.final_budget,
        next_year_budget: form.next_year_budget,
        src: form.src,
      });
      this.isFormShown = true;
    },
    async onModalConfirmed(form) {
      const toUpdate = { ...form };
      if (toUpdate.id) {
        if (typeof toUpdate.src === "string") delete toUpdate.src;
        await this.editFinancialData(toUpdate);
      } else await this.addFinancialData(toUpdate);
      this.isFormShown = false;
      this.$refs.financialGrantTable.refreshTable();
    },
    onNewClicked() {
      this.$refs.financialDataForm.init({});
      this.isFormShown = true;
    },
    async onConfirmAddRequest(form){
      const keys = Object.keys(form);
      var req = new FormData();
      req.append("slug", "collaboration_two_local_partners");
      for (const index in keys) {
        const key = keys[index];
        if(`${key}` ==='file') {
          req.append(`data[${index}][field_name]`, `${key}`);
          req.append(`data[${index}][field_value]`, form.file);

        }
        else if (`${key}` === 'ngo_name'){
        }
        else{
          req.append(`data[${index}][field_name]`, `${key}`);
          req.append(`data[${index}][field_value]`, `${form[key]}`);

        }
      }
      this.createTransactions(req).then(() => {
        this.$refs.collaborationTable.refreshTable();
        this.collaborationModal = false 
      })
      .catch((err) => {
        console.log(err)
      });

    },
  },
    
    created() {
    let userData = JSON.parse(localStorage.getItem("user")) 
    this.form.ngo_name = userData.ngo.name_ar
    this.form.ngo_id = userData.ngo.id
    
    },
    mounted(){
      this.$refs.financialGrantModal.init(this.form);
    }
};
</script>
